import { Button, Center, Flex, Heading, VStack } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { Clinic } from '../../types'
import ClinicForm from '../ClinicPage/ClinicForm'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import useApi from '../../common/utils/api/useApi'
import { ClinicClient } from '../NewScriptPage/ScriptForm/ClinicContextSlice'
import { createOrganization } from '../OrganizationProfilePage/OrganizationSlice'
import { routes } from '../routes'
import { useAppDispatch } from '../../app/typedReduxHooks'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { STATUS } from '../../constants'
import { Logo } from '../../components/shared-components/Logo'
import { setOrganizationId } from '../../features/onboardingContext/OnboardingContextSlice'
import { setClinicId } from '../../features/onboardingContext/OnboardingContextSlice'
import { appDidFinishLaunching } from '../../app/appSlice'

const ClinicCreationPage = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { CreatePrescriber: createPrescriberLoading } = useSelector(
    (state: RootState) => state.prescriber.status
  )
  const [isLoading, setIsLoading] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true)
  const { selectedRole } = useSelector((state: RootState) => state.onboardingContext)
  const { trigger: triggerCreateOrganization, loading: createOrgLoading } = useApi(
    createOrganization,
    {
      onSuccess: async (organization) => {
        await dispatch(setOrganizationId(organization.id))
        if (selectedRole === 'prescriber') {
          navigate(routes.createPrescriberProfile.path)
        } else {
          // Handle admin, PATIENT_ADMIN, and RX_ADMIN roles
          await dispatch(appDidFinishLaunching())
          navigate(routes.settings.path)
        }
      },
    }
  )
  const { trigger: triggerCreateClinic, loading: createClinicLoading } = useApi(
    ClinicClient.createClinic,
    {
      onSuccess: async (clinic) => {
        await dispatch(setClinicId(clinic.id))
        await triggerCreateOrganization({
          clinicId: clinic.id,
        })
      },
    }
  )
  useEffect(() => {
    if (!selectedRole) {
      navigate(routes.selectRoles.path)
    }
  }, [selectedRole])

  useEffect(() => {
    setIsLoading(
      createClinicLoading || createOrgLoading || createPrescriberLoading === STATUS.PENDING
    )
  }, [createClinicLoading, createOrgLoading, createPrescriberLoading])

  const createClinic = async () => {
    await triggerCreateClinic(getValues())
  }

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {} as Clinic,
  })

  return (
    <VStack overflow="auto" p="24px" minHeight="100%" spacing="16">
      <Center>
        <Logo maxWidth={150} />
      </Center>
      <Flex
        direction="column"
        gap="6"
        shadow="2xl"
        borderRadius="md"
        p="12"
        mt="12"
        width={'60%'}
        margin={'auto'}
      >
        <Heading as="h2" alignSelf="center" size="lg" mt={1}>
          Create a New Organisation
        </Heading>
        <VStack
          flexGrow="1"
          overflow="auto"
          flexDirection="column"
          alignItems="center"
          spacing={10}
          width="100%"
        >
          <ClinicForm
            setIsDisabled={setIsDisabled}
            {...{
              register,
              errors,
              getValues,
              setValue,
            }}
          />
          <Button
            colorScheme="blue"
            width={218}
            onClick={handleSubmit(createClinic)}
            isLoading={isLoading}
            disabled={isLoading || Object.keys(errors).length > 0 || isDisabled}
          >
            Create and Link Now
          </Button>
        </VStack>
      </Flex>
    </VStack>
  )
}
export default ClinicCreationPage
